// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Z44q","description":"PatientConsentPreview_description__2nDew"};